import PropertyComposite from "./PropertyComposite";


export default function SectorBorders({sector}) {
    const propRad = sector.getProperty('border-radius');

    return (
        <>
            <PropertyComposite property={propRad} corners/>
            <PropertyComposite property={sector.getProperty('border-width')}/>
            <PropertyComposite property={sector.getProperty('border-style')}/>
            <PropertyComposite property={sector.getProperty('border-color')}/>
        </>
    );
}